<template>
	<div>
		<el-row>
			<el-col :span="24" class="bread">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item v-if="$store.state.main.user.m_qaedas_id==0" :to="{ path: '/main' }">基地管理</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/iot/terminal' }">终端管理</el-breadcrumb-item>
					<el-breadcrumb-item>留样柜管理</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24">
				<div @click="choice(item)" class="card-dis" v-for="item in SampleData" :key="item.id">
					<el-col :md="9" v-show="!$store.state.isphone">
						<div class="img-div">
							<div class="img-state" :style="'background-color: '+(item.sampleOnLineStatus==1?'green;':'red;')">
								<i :class='item.sampleOnLineStatus==1?"el-icon-success":"el-icon-error"'></i>{{item.sampleOnLineStatus==1?"在线":"离线"}}
							</div>
							<img :src="config.apiurl+item.image" alt="">
							<div class="img-state2" style="color: green;">
								<i :class='item.samples_switch==1?"my-icon-opendoor":"my-icon-closedoor"' style="font-size: 18px;"></i>{{item.samples_switch==1?"已开门":"已关门"}}
							</div>
							<div class="img-warn">{{item.energyName}}</div>
						</div>
					</el-col>
					<el-col :md="15">
						<el-col :span="24">
							<br>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								样柜名称：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.name}}
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								电池电量：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.energy}} V
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								开门总数：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.doorNum}} 次
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								关门总数：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.closedNum}} 次
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								供电方式：
							</el-col>
							<el-col :span="16" class="card-content">
								{{item.supply}}
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								{{item.distanceSampleName}}：
							</el-col>
							<el-col :span="16" class="card-content">
								<duration-time v-model="item.distanceSampleValue" :control="false"></duration-time>
							</el-col>
						</el-col>
						<el-col :span="24">
							<el-col :span="8" class="card-title">
								{{item.distanceSampleOnLineName}}：
							</el-col>
							<el-col :span="16" class="card-content">
								<duration-time v-model="item.distanceSampleOnLineValue" :control="false"></duration-time>
							</el-col>
						</el-col>
						<div class="card-time">采集时间：{{Totime(item.updateTime)}}</div>
					</el-col>
				</div>
			</el-col>
		</el-row>
		<el-row v-if="show">
			<el-col :span="24" v-if="SampleData.length>0">
				<el-tabs type="border-card">
					<el-tab-pane label="留样柜报警记录">
						<crud :fields="alarmlog" :select="[]" :limits="limits" apiU="Samplealarmlog"></crud>
					</el-tab-pane>
					<el-tab-pane label="留样柜日志">
						<crud :fields="log" :select="selectlog" :limits="limits" apiU="Samplelog"></crud>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				SampleData: [],
				show: true,
				timer: null,
				alarmlog: [{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'alarmStatus',
						label: '报警状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "电量不足报警",
									value: 1
								},
								{
									label: "离线报警",
									value: 2
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				log: [{
						name: 'name',
						label: '名称',
						type: 'string',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'sampleLogStatus',
						label: '状态',
						type: 'select',
						selection: {
							prop: {
								label: 'label',
								value: 'value'
							},
							data: [{
									label: "在线",
									value: 1
								},
								{
									label: "离线",
									value: 2
								},
								{
									label: "开门",
									value: 3
								},
								{
									label: "关门",
									value: 4
								}
							]
						},
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'switchDuration',
						label: '距上次操作时长',
						type: 'time',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'createTime',
						label: '时间',
						type: 'date',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					},
					{
						name: 'description',
						label: '描述',
						type: 'text',
						limits: {
							look: true,
							add: true,
							edit: true,
							table: true,
							phone: true
						}
					}
				],
				limits: {
					add: false,
					delete: false,
					edit: false,
					find: true,
					export: true,
					look: true
				},
				selectlog: [{
					name: 'sampleLogStatus',
					selection: {
						prop: {
							label: 'label',
							value: 'value'
						},
						data: [{
								label: "在线",
								value: 1
							},
							{
								label: "离线",
								value: 2
							},
							{
								label: "开门",
								value: 3
							},
							{
								label: "关门",
								value: 4
							}
						]
					}
				}]
			}
		},
		methods: {
			load() {
				this.api.Sample.getList({
						terminalId: this.$route.query.id
					})
					.then((res) => {
						this.SampleData = res.data.data.list;
						if (this.SampleData.length > 0) {
							this.$router.push({
								path: '/iot/Sample',
								query: {
									Did: this.SampleData[0].id,
									id: this.$route.query.id
								}
							});
						}
					})
			},
			choice(item) {
				this.show = false;
				this.$router.push({
					path: '/iot/Sample',
					query: {
						Did: item.id,
						id: this.$route.query.id
					}
				});
				setTimeout(() => {
					this.show = true;
				}, 10);

			}
		},
		filters: {

		},
		mounted() {
			this.load();
			clearInterval(this.timer);
			this.timer = setInterval(this.load, 5000); //刷新
		},
		beforeDestroy() {
			clearInterval(this.timer);
		},
		computed: {

		}
	}
</script>

<style scoped>
	.bread {
		margin: 15px 0px;
	}

	.card-dis {
		float: left;
		position: relative;
		width: 500px;
		height: 245px;
		margin-bottom: 15px;
		background-color: white;
		border-radius: 5px;
		margin-right: 10px;
		cursor: pointer;
	}

	.card-time {
		position: absolute;
		bottom: 2px;
		right: 0;
		width: 62.5%;
		font-size: 12px;
		text-align: center;
		/* padding-right: 1em; */
	}

	.card-dis img {
		border-radius: 5px 0 0 5px;
		width: 86%;
		height: 207px;
		margin: 7%;
		margin-bottom: 8%;
	}

	.img-div {
		position: relative;
		overflow: hidden;
	}

	.img-warn {
		position: absolute;
		top: -1px;
		right: 0;
		width: 100%;
		text-align: center;
		color: red;
		font-size: 12px;
	}

	.img-state {
		position: absolute;
		right: -35px;
		top: 5px;
		transform: rotate(45deg);
		background-color: gray;
		color: white;
		font-size: 12px;
		width: 100px;
		text-align: center;
	}

	.img-state2 {
		position: absolute;
		right: 0;
		bottom: 0;
		width: 100%;
		text-align: center;
		line-height: 22px;
	}

	.card-title {
		padding-left: 1em;
		color: #606266;
		font-size: 14px;
		line-height: 28px;
	}

	.card-content {
		color: #303133;
		line-height: 28px;
	}

	.card-title-s {
		padding-left: 1em;
		color: #606266;
		font-size: 12px;
	}

	.card-content-s {
		padding-left: 2em;
		color: #303133;
		line-height: 25px;
	}

	@media screen and (min-width: 0px) and (max-width: 700px) {
		.bread {
			margin: 5px 0px;
		}

		.card-dis {
			width: 100%;
			height: 220px;
			margin-bottom: 5px;
		}

		.card-title {
			padding-left: 0em;
			line-height: 25px;
		}

		.card-content {
			line-height: 25px;
		}

		.card-title-s {
			padding-left: 0em;
		}

		.card-content-s {
			padding-left: 1em;
			line-height: 25px;
		}
	}
</style>
